import moment from "moment";
import React from "react";

import { ThemeRequestReceipt } from "./themeRequestReceipts";

interface Props {
  receipt: ThemeRequestReceipt;
  onRemove: () => void;
}

/**
 * Transcript record of a submitted theme request: what was sent, and when. Sits in the message
 * flow (the form itself docks above the composer) so scrolling back shows the request in place.
 */
export const ChatThemeRequestReceipt: React.FC<Props> = ({ receipt, onRemove }) => (
  <div className="group relative shrink-0 rounded-xl border border-gray-300 bg-white">
    <div className="flex items-start gap-2 px-3 py-3">
      <span className="mt-0.5 grid size-[18px] shrink-0 place-items-center rounded-full bg-[#067647] text-[11px] leading-none text-white">
        ✓
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2">
          <span className="text-[13px] font-semibold text-[#111215]">Theme request sent</span>
          <span className="text-[11px] text-gray-400">
            {moment(receipt.submittedAt).format("h:mm A")}
          </span>
        </div>
        {receipt.summary && (
          <div className="mt-0.5 line-clamp-2 text-xs text-gray-600">{receipt.summary}</div>
        )}
        {receipt.tags.length > 0 && (
          <div className="mt-1.5 flex flex-wrap gap-1.5">
            {receipt.tags.map(tag => (
              <span
                key={tag}
                className="max-w-full truncate rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold text-gray-600"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={onRemove}
        aria-label="Remove this record"
        className="grid size-6 shrink-0 cursor-pointer place-items-center rounded text-gray-400 opacity-0 transition-opacity hover:bg-gray-100 hover:text-gray-900 focus:opacity-100 group-hover:opacity-100"
      >
        <span className="material-icons !text-[16px] leading-none">close</span>
      </button>
    </div>
  </div>
);
